import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { client } from "../lib/config";
import SEOHead from "../lib/SEOHead";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await client.post("/auth/login", { email, password });
      if (data.access_token) {
        localStorage.setItem("wb_admin_token", data.access_token);
        toast.success("Welcome back.");
        navigate("/admin");
      }
    } catch (err) {
      const d = err?.response?.data?.detail;
      const msg = typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEOHead title="Admin Login" description="Staff login" />
      <section className="min-h-[80vh] flex items-center bg-[#F5F0E6]">
        <div className="wb-container">
          <div className="max-w-md mx-auto wb-card p-8 md:p-10 bg-white">
            <img
              src="/images/logo-horizontal.png"
              alt="Westbridge Inn & Suites"
              className="h-12 w-auto mb-6"
            />
            <div className="wb-eyebrow">Staff area</div>
            <h1 className="wb-h3 mt-2">Sign in to admin</h1>
            <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  data-testid="admin-email-input"
                  className="mt-1"
                />
              </div>
              <div>
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  data-testid="admin-password-input"
                  className="mt-1"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="wb-btn-primary w-full"
                data-testid="admin-login-submit"
              >
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
